__turbopack_context__.v({
  "btn-class-name": "toggle-button-module-scss-module___Ld9MW__btn-class-name",
  "container": "toggle-button-module-scss-module___Ld9MW__container",
  "full-width": "toggle-button-module-scss-module___Ld9MW__full-width",
  "rounded": "toggle-button-module-scss-module___Ld9MW__rounded",
  "vertical": "toggle-button-module-scss-module___Ld9MW__vertical",
});
